/** Station-rate day flags (rates are keyed by name, Monday-first; see utils/day-of-week.ts). */
export interface RateDayFlags {
  mon?: boolean | number | null
  tue?: boolean | number | null
  wed?: boolean | number | null
  thu?: boolean | number | null
  fri?: boolean | number | null
  sat?: boolean | number | null
  sun?: boolean | number | null
}

const RATE_DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const

export const RATE_DAY_SHORT_LABELS: readonly string[] = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]

/**
 * Compact label for a rate's days: contiguous runs become ranges ("Mon-Wed") and separate
 * runs are joined with ", " — so Mon+Wed is "Mon, Wed", never "Mon-Wed" (which reads as a
 * Mon–Wed range and hides that Tuesday is excluded).
 */
export function formatRateDayRuns(
  days: RateDayFlags | null | undefined,
  labels: readonly string[] = RATE_DAY_SHORT_LABELS,
): string {
  if (!days) return ""
  const on = RATE_DAY_KEYS.map((k) => !!days[k])
  const parts: string[] = []
  let i = 0
  while (i < on.length) {
    if (!on[i]) {
      i++
      continue
    }
    let j = i
    while (j + 1 < on.length && on[j + 1]) j++
    parts.push(j > i ? `${labels[i]}-${labels[j]}` : labels[i])
    i = j + 1
  }
  return parts.join(", ")
}
